import { gql } from 'graphql-request';

export type GetWorkSessionResponse = {
  propertyById: {
    activeWorkSession: {
      id: number;
      expiresAt: string;
      createdBy: string | null;
    } | null;
  };
};

export const GET_WORK_SESSION = gql`
  query getWorkSession($id: Int!) {
    propertyById(id: $id) {
      activeWorkSession {
        id
        expiresAt
        createdBy
      }
    }
  }
`;

export type StartWorkSessionResponse = {
  startWorkSession: {
    workSession: {
      id: number;
      propertyId: number;
      createdAt: string;
      expiresAt: string;
    };
  };
};

export const START_WORK_SESSION = gql`
  mutation StartWorkSession($propertyId: Int!) {
    startWorkSession(input: { propertyId: $propertyId }) {
      workSession {
        id
        propertyId
        createdAt
        expiresAt
      }
    }
  }
`;

export type StopWorkSessionResponse = {
  stopWorkSession: boolean;
};

export const STOP_WORK_SESSION = gql`
  mutation StopWorkSession($workSessionId: Int!) {
    stopWorkSession(input: { workSessionId: $workSessionId })
  }
`;
